function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
var _excluded = ["initialIds", "mode"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function _objectWithoutProperties(e, t) { if (null == e)
    return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
        o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
} return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r)
    return {}; var t = {}; for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n))
            continue;
        t[n] = r[n];
    } return t; }
import { useEffect, useState, useRef } from 'react';
import { Select } from 'antd';
import { Api_v2 } from '../../services/api';
import { jsx as _jsx } from "react/jsx-runtime";
export var UserPicker = function UserPicker(_ref) {
    var initialIds = _ref.initialIds, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "multiple" : _ref$mode, propsPropagate = _objectWithoutProperties(_ref, _excluded);
    var _useState = useState(), _useState2 = _slicedToArray(_useState, 2), userOptions = _useState2[0], setUserOptions = _useState2[1];
    var _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), isLoading = _useState4[0], setIsLoading = _useState4[1];
    var lastUsedInitialIds = useRef();
    var _useState5 = useState(function () {
        return runOnlyOnceOnClickHandler;
    }), _useState6 = _slicedToArray(_useState5, 2), onClickHandler = _useState6[0], setOnClickHandler = _useState6[1];
    var userRequestParams = {};
    var onSearchTimeoutId;
    useEffect(function () {
        var shouldUpdateOptions = false;
        var initialIdsIsNotEmptyOrUndefined = initialIds && initialIds.length > 0;
        if (initialIdsIsNotEmptyOrUndefined) {
            var lasUsedNotEmptyAndSameLength = lastUsedInitialIds.current && lastUsedInitialIds.current.length === initialIds.length;
            if (lasUsedNotEmptyAndSameLength) {
                for (var i = 0; i < initialIds.length; i++) {
                    if (lastUsedInitialIds.current[i] !== initialIds[i]) {
                        shouldUpdateOptions = true;
                        break;
                    }
                }
            }
            else {
                shouldUpdateOptions = true;
            }
        }
        if (shouldUpdateOptions) {
            lastUsedInitialIds.current = initialIds;
            getAndSetOptions(_objectSpread(_objectSpread({}, userRequestParams), {}, {
                filterIDs: initialIds
            }));
        }
    }, [initialIds]);
    function getAndSetOptions(request) {
        setIsLoading(true);
        Api_v2.User.getAll(request).then(function (r) {
            var options = r.data.response.items.map(function (e) {
                return {
                    value: e.id,
                    label: e.name
                };
            });
            setUserOptions(options);
        })["finally"](function () {
            setIsLoading(false);
        });
    }
    function runOnlyOnceOnClickHandler() {
        setOnClickHandler(undefined);
        getAndSetOptions(userRequestParams);
    }
    function onSearchHandler(search) {
        window.clearTimeout(onSearchTimeoutId);
        onSearchTimeoutId = window.setTimeout(function () {
            userRequestParams.searchText = search;
            getAndSetOptions(userRequestParams);
        }, 300);
    }
    return /*#__PURE__*/ _jsx(Select, _objectSpread({
        autoClearSearchValue: false,
        filterOption: false,
        showArrow: true,
        showSearch: true,
        onClick: onClickHandler,
        allowClear: true,
        loading: isLoading,
        mode: mode,
        onSearch: onSearchHandler,
        options: userOptions
    }, propsPropagate));
};
